import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as CloudConnectionIcon } from "../../assets/cloud-connection.svg";

export const CloudConnection = (props: SvgIconProps) => {
  return (
    <SvgIcon component={CloudConnectionIcon} {...props} viewBox="0 0 32 32" />
  );
};
